export const services = [
  {
    id: 1,
    name: 'Waxing',
    nameAr: 'تلميع واكس',
    description:
      'Premium wax application to enhance shine and provide surface protection.',
    descriptionAr:
      'تطبيق واكس بريميوم لتعزيز اللمعان وتوفير حماية لسطح السيارة.',
    price: '4',
    duration: '30 mins',
    durationAr: '٣٠ دقيقة',
    features: [
      'Premium wax application',
      'Gloss enhancement',
      'Paint protection',
      'Water beading effect',
    ],
    featuresAr: [
      'تطبيق واكس عالي الجودة',
      'تعزيز لمعان الصبغ',
      'حماية طلاء السيارة',
      'تأثير طارد للمياه',
    ],
  },
  {
    id: 2,
    name: 'Polishing',
    nameAr: 'بوليش (تلميع خارجي)',
    description:
      'Professional machine polishing to restore paint clarity and remove minor scratches.',
    descriptionAr:
      'تلميع احترافي بالماكينة لاستعادة وضوح الصبغ وإزالة الخدوش البسيطة.',
    price: '12',
    duration: '60 mins',
    durationAr: '٦٠ دقيقة',
    features: [
      'Scratch reduction',
      'Swirl mark removal',
      'Deep gloss finish',
      'Surface smoothening',
    ],
    featuresAr: [
      'تقليل الخدوش الواضحة',
      'إزالة دوائر الغسيل (Swirls)',
      'لمعة عميقة وجذابة',
      'تنعيم سطح الهيكل',
    ],
  },
  {
    id: 3,
    name: 'Leather Seat Treatment',
    nameAr: 'عناية الكراسي الجلد',
    description:
      'Special leather cleaning and conditioning treatment for long-lasting softness and protection.',
    descriptionAr: 'تنظيف وترطيب خاص للجلد لضمان النعومة والحماية لفترة طويلة.',
    price: '3',
    duration: '30 mins',
    durationAr: '٣٠ دقيقة',
    features: [
      'Leather deep cleaning',
      'Conditioning treatment',
      'Crack prevention',
      'Premium finish',
    ],
    featuresAr: [
      'تنظيف عميق للجلد',
      'معالجة وترطيب الجلد',
      'منع تشقق الكراسي',
      'ملمس ناعم وفاخر',
    ],
  },
  {
    id: 4,
    name: 'Window Polishing',
    nameAr: 'بوليش زجاج',
    description:
      'Glass polishing service to improve clarity and remove light scratches or stains.',
    descriptionAr:
      'خدمة تلميع الزجاج لتحسين الرؤية وإزالة الخدوش الخفيفة والبقع.',
    price: '6',
    duration: '30 mins',
    durationAr: '٣٠ دقيقة',
    features: [
      'Glass stain removal',
      'Scratch reduction',
      'Clear visibility',
      'Water spot removal',
    ],
    featuresAr: [
      'إزالة بقع الزجاج الصعبة',
      'تقليل الخدوش الزجاجية',
      'رؤية واضحة جداً',
      'إزالة آثار الأمطار والأملاح',
    ],
  },
  {
    id: 5,
    name: 'Engine Cleaning',
    nameAr: 'تنظيف محرك (مكينة)',
    description:
      'Safe and careful engine bay cleaning using professional products.',
    descriptionAr:
      'تنظيف محرك السيارة بعناية وحذر باستخدام منتجات احترافية آمنة.',
    price: '3',
    duration: '30 mins',
    durationAr: '٣٠ دقيقة',
    features: [
      'Degreasing',
      'Safe wash process',
      'Dust removal',
      'Engine bay shine',
    ],
    featuresAr: [
      'إزالة الشحوم والزيوت',
      'عملية غسيل آمنة للمحرك',
      'إزالة الأتربة المتراكمة',
      'تلميع وحماية المحرك',
    ],
  },
  {
    id: 6,
    name: 'Stains Removal',
    nameAr: 'إزالة البقع المستعصية',
    description: 'Deep stain removal treatment for fabric or leather seats.',
    descriptionAr:
      'معالجة عميقة لإزالة البقع الصعبة من الكراسي المخمل أو الجلد.',
    price: '14',
    duration: '45 mins',
    durationAr: '٤٥ دقيقة',
    features: [
      'Deep stain extraction',
      'Fabric safe chemicals',
      'Odor removal',
      'Spot treatment',
    ],
    featuresAr: [
      'سحب البقع من العمق',
      'مواد آمنة على الأنسجة',
      'إزالة الروائح الكريهة',
      'معالجة دقيقة لمكان البقعة',
    ],
  },
  {
    id: 7,
    name: 'AC Sanitizing',
    nameAr: 'تعقيم التكييف',
    description:
      'Complete AC system sanitizing to remove bacteria, odor, and improve air quality.',
    descriptionAr:
      'تعقيم كامل لنظام التكييف لإزالة البكتيريا والروائح وتحسين جودة الهواء.',
    price: '9',
    duration: '30 mins',
    durationAr: '٣٠ دقيقة',
    features: [
      'AC vent cleaning',
      'Bacteria removal',
      'Odor treatment',
      'Fresh air circulation',
    ],
    featuresAr: [
      'تنظيف فتحات التكييف',
      'القضاء على البكتيريا',
      'علاج الروائح غير المحببة',
      'تدوير هواء نقي ومنعش',
    ],
  },
];
